export default "__VITE_ASSET__B1vk$OpF__"